// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__ChSfl","label":"Radio_label__3x_uH","checkMark":"Radio_checkMark__B579E","disabled":"Radio_disabled__3b9ye"};